module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./~/raw-loader!./~/sass-loader/lib/loader.js!./src/components/user-info.component.scss
// module id = 13
// module chunks = 0